import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSortAlphaAsc,
  faSortAlphaDesc,
  faSortAmountDown,
} from "@fortawesome/free-solid-svg-icons";

import StudentRow from "./StudentRow";
import { EmailVerifiedBadge, StatusBadge } from "../common/Modal";
import { formatDate } from "./userUtils";

function StudentTable({
  students,
  loading,
  error,
  onView,
  onSuspend,
  sort,
  sortDir,
  toggleSort,
}) {
  const sortIcon = (field) => {
    if (sort !== field)
      return (
        <FontAwesomeIcon
          icon={faSortAmountDown}
          className="ml-1 text-[10px] text-slate-300"
        />
      );
    return sortDir === "asc" ? (
      <FontAwesomeIcon icon={faSortAlphaAsc} className="ml-1 text-[10px] text-blue-600" />
    ) : (
      <FontAwesomeIcon icon={faSortAlphaDesc} className="ml-1 text-[10px] text-blue-600" />
    );
  };

  const thClass =
    "cursor-pointer border-b border-slate-200 px-3 py-2.5 text-left text-slate-600";
  const tdClass = "px-3 py-2.5";

  return (
    <table className="admin-table-responsive w-full min-w-[760px] border-collapse text-[13px]">
      <thead>
        <tr>
          <th className={thClass} onClick={() => toggleSort("fullName")}>
            Name {sortIcon("fullName")}
          </th>
          <th className={thClass} onClick={() => toggleSort("email")}>
            Email {sortIcon("email")}
          </th>
          <th className={thClass}>Phone</th>
          <th className={thClass}>Email Verified</th>
          <th className={thClass}>Status</th>
          <th className={thClass} onClick={() => toggleSort("createdAt")}>
            Date Joined {sortIcon("createdAt")}
          </th>
          <th className="border-b border-slate-200 px-3 py-2.5 text-right text-slate-600">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        {students.map((user, index) => (
          <tr key={user.id || index} className="border-b border-slate-100 hover:bg-slate-50">
            <td data-label="Name" className={tdClass}>
              <div className="flex items-center gap-2.5">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-100 text-[13px] font-semibold text-slate-600">
                  {String(user.name || "?")
                    .split(" ")
                    .map((n) => n[0] || "")
                    .join("")
                    .toUpperCase()}
                </span>
                <span className="font-medium text-slate-700">{user.name || "--"}</span>
              </div>
            </td>
            <td data-label="Email" className={`${tdClass} text-slate-600`}>
              {user.email || "--"}
            </td>
            <td data-label="Phone" className={`${tdClass} text-slate-500`}>
              {user.phoneNumber || "--"}
            </td>
            <td data-label="Email Verified" className={tdClass}>
              <EmailVerifiedBadge value={user.emailVerified} />
            </td>
            <td data-label="Status" className={tdClass}>
              <StatusBadge isActive={user.isActive} accountStatus={user.accountStatus} />
            </td>
            <td data-label="Date Joined" className={`${tdClass} whitespace-nowrap text-slate-500`}>
              {formatDate(user.createdAt || user.dateAdded)}
            </td>
            <td data-label="Actions" className={tdClass}>
              <StudentRow
                index={index}
                student={user}
                onView={onView}
                onSuspend={onSuspend}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default StudentTable;